import React from 'react';

interface DetailsRowProps {
  label?: React.ReactNode;
  value?: React.ReactNode;
}

// Displays 2 columns table row with correct textAlign
function DetailsRow({ label, value }: DetailsRowProps) {
  return (
    <tr>
      <td>{label}</td>
      <td>{value}</td>
    </tr>
  );
}

export default DetailsRow;
